import styled, { css, CSSObject } from 'styled-components';
import { getScrollBarStyles } from '../../config/styles';
import { theme } from '../../styles/theme';
import { level1Content, optionHover } from '../../styles/shareableStyles';
import { ChartMode } from './types';

export const Container = styled.div<{
  $isSelected?: boolean;
  $isDragging?: boolean;
}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  ${level1Content};

  border-radius: 8px;
  > :last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  > :not(:first-child) {
    border-top: 1px solid ${theme.colors.border};
  }

  ${({ $isDragging }) =>
    $isDragging &&
    css`
      opacity: 0.6;
    `}
`;

const chartWrapperStylesPerMode: Record<ChartMode, CSSObject> = {
  [ChartMode.Build]: {
    padding: '0px',
    rowGap: '12px',
    '--chart-row-gap': '12px',
  },
  [ChartMode.View]: {
    padding: '8px 16px',
    rowGap: '8px',
    '--chart-row-gap': '8px',
  },
  [ChartMode.Compact]: {
    // Special CSS-hack:
    // By default, height is 0 but flexbox will recalculate it
    height: 0,
    maxHeight: '100%',
    overflowY: 'auto',
    padding: '8px',
    '--chart-row-gap': 0,
  },
};

export const ChartMainWrapper = styled.div<{ $mode: ChartMode }>`
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  color: ${theme.colors.secondary800};
  ${getScrollBarStyles(4)};
  ${({ $mode }) => chartWrapperStylesPerMode[$mode]};
`;

const compactHeaderWrapperStyles = css<{ $isDisabled?: boolean }>`
  row-gap: 2px;
  min-height: 50px;
  padding: 8px 16px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  ${({ $isDisabled }) =>
    !$isDisabled &&
    css`
      &:hover {
        cursor: pointer;
        ${optionHover};
      }
    `}
`;
const defaultHeaderWrapperStyles = css`
  row-gap: 4px;
  min-height: 80px;
  padding: 16px;
`;

export const Header = styled.div<{
  $mode: ChartMode;
  $isDisabled?: boolean;
}>`
  position: relative;
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: ${theme.colors.secondary900};
  ${({ $mode }) =>
    $mode !== ChartMode.Build
      ? compactHeaderWrapperStyles
      : defaultHeaderWrapperStyles};
`;
